export const EXPECTED_CSV_COLUMNS_TEXT =
	'Expected columns: Kampania, Dzień, Kod waluty, Koszt.';
export const EXPECTED_CSV_COLUMNS_TEXT_2 =
	'Parser skips the first two header rows (Title and Date Range).';
